import { patch, post } from '@va/http-client';
import { getUserId } from '@va/standalone/shared/helpers';
import { selectAgencyUIId } from '@va/standalone/shared/selectors';
import { ThemeType } from '@va/ui/components/white-label-customisation';
import { useAsyncFunction, useFetchData } from '@va/util/hooks';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useGetAllAgencyThemes = () => {
  const userId = getUserId();
  return useFetchData<ThemeType[]>(`/users/${userId}/agencyui/theme/all`);
};

export const useEditTheme = () => {
  const asyncFunc = useCallback((themeId: string, data: Object) => {
    const userId = getUserId();
    return patch(`/users/${userId}/agencyui/theme/${themeId}`, {}, data);
  }, []);
  return useAsyncFunction<typeof asyncFunc>(asyncFunc);
};

export const useCreateNewTheme = () => {
  const userId = getUserId();
  const asyncFunc = useCallback(
    (data: Object) => post<ThemeType>(`/users/${userId}/agencyui/theme`, {}, data),
    [userId],
  );
  return useAsyncFunction(asyncFunc);
};

export const useUpdateAgencyUi = () => {
  const agencyUiId = useSelector(selectAgencyUIId);
  const asyncFunc = useCallback(
    (data: Object) => {
      const userId = getUserId();
      return patch(`/users/${userId}/agencyui/${agencyUiId}`, {}, data);
    },
    [agencyUiId],
  );
  return useAsyncFunction<typeof asyncFunc>(asyncFunc);
};

export const useSendDummyEmail = () => {
  const agencyUIId = useSelector(selectAgencyUIId);
  const asyncFunc = useCallback(
    async (email: string, type?: 'reply_to_dummy' | 'sent_by_dummy') => {
      const userId = getUserId();
      return post(`/users/${userId}/agencyui/${agencyUIId}/dummy-email`, {}, { emailTo: email, type });
    },
    [agencyUIId],
  );
  return useAsyncFunction<typeof asyncFunc>(asyncFunc);
};
